import styled from 'styled-components'

export const SectionHeader = styled.span`
    display:flex;
    justify-content: center;
    margin-top:10px;
    margin-bottom:14px;
    font-size: 16px;
`;